export enum OwnershipType {
  OWN = 'own',
  LEASING = 'leasing',
  LOAN = 'loan',
  RENTAL = 'rental',
}
